<template>
  <div class="themeBody" :data-theme="themeMode">

    <div class="mainBoxForm">
      <div class="loginBoxHeader">QIDI Tech</div>
      <div class="loginFormBox">

        <el-form :model="ruleForm" ref="ruleForm" :rules="getRules" label-width="0px">
          <el-tabs style="display: inline-block" value="passwordLogin" :stretch=true @tab-click="handleTabClick">
            <el-form-item class="formInputWidth" prop="userEmail">
              <el-input v-model="ruleForm.userEmail" :placeholder="$t('h.common.email')+'*'" clearable></el-input>
            </el-form-item>
            <el-tab-pane  name="passwordLogin">
              <template #label>
                <div class="loginFormBoxHeader">
                  {{ $t('h.login.passwordLogin') }}
                </div>
              </template>

              <el-form-item class="formInputWidth" style="padding-bottom: 30px" prop="password" v-show="chooseTabName==='passwordLogin'">
                <el-input  v-model="ruleForm.password" :placeholder="$t('h.common.password')+'*'" autocomplete="off"
                          :type="showPassword ? 'text' : 'password'">
                  <i slot="suffix" @click="switchPassword">
                    <img
                        v-if="showPassword"
                        class="input_icon"
                        :src="require('@/assets/icons/password_show.png')"
                    />
                    <img
                        v-else
                        class="input_icon"
                        :src="require('@/assets/icons/password_hide.png')"
                    />
                  </i>
                </el-input>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane name="emailLogin">
              <template #label>
                <div class="loginFormBoxHeader">
                  {{ $t('h.login.verifyLogin') }}
                </div>
              </template>

              <el-form-item class="formInputWidth" style="padding-bottom: 30px" prop="emailCode"
                            v-show="chooseTabName==='emailLogin'">
                <el-input  v-model="ruleForm.emailCode" :placeholder="$t('h.common.verificationCode')+'*'"
                          autocomplete="off" clearable>
                  <template #suffix>
                    <el-button :class="'sendCodeBtn'" @click="sendVerificationCode"
                               :disabled="isSendingCode || codeCountDown > 0">
                      {{
                        isSendingCode ? $t('h.common.Sending') + '...' : (codeCountDown > 0 ? `${codeCountDown}` + 's' : $t('h.common.sendVerificationCode'))
                      }}
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
          <div  style="display: flex; justify-content: space-between;width: 330px;margin: 0 auto;">
            <div style="text-align: left;">
              <a class="elLinkFooter agreeA" href="#/account/register" :underline="true">
                {{ $t('h.login.accountRegistration') }}
              </a>
            </div>
            <div style="text-align: right;" v-if="chooseTabName==='passwordLogin'">
              <a class="elLinkFooter agreeA"  href="#/account/forgotPassword" :underline="true">
                {{ $t('h.login.forgotPassword') }}
              </a>
            </div>
          </div>
          <el-form-item prop="checked" class="formCheckBox">
            <el-checkbox class="myCheckBox" v-model="ruleForm.checked" name="checked">
              <template v-slot:default>
                <div class="checkbox-content">{{ $t('h.common.readAndAgree') }}
                  <a @click="isOpenUserAgreement" class="agreeA">{{ $t('h.common.userAgreement') }}
                  </a>
                  {{ $t('h.common.and') }}
                  <a @click="isOpenPrivacyPolicy" class="agreeA">{{ $t('h.common.privacyPolicy') }}
                  </a>
                </div>
              </template>
            </el-checkbox>
          </el-form-item>

          <error-msg :errorMsg="errorMsg"/>

          <el-form-item class="formInputWidth">
            <el-button  type="primary" class="subBtn" :style="getSubStyle" :disabled="isActiveSub"
                       @click="submitForm('ruleForm')">{{ $t('h.login.login') }}
            </el-button>
          </el-form-item>
        </el-form>

        <!--        <el-divider content-position="center">第三方登录</el-divider>-->
        <!--        -->
        <!--        &lt;!&ndash;    <i class="fa fa-qq"></i>&ndash;&gt;-->
        <!--        <div class="iconStyle">-->
        <!--          <el-button class="qq" icon="fa fa-qq" circle></el-button>-->
        <!--          <el-button class="weixin" icon="fa fa-weixin" circle></el-button>-->
        <!--          <el-button class="weibo" icon="fa fa-weibo" circle></el-button>-->
        <!--          &lt;!&ndash;图标偏窄 apple&ndash;&gt;-->
        <!--          <el-button class="apple" icon="fa fa-apple" circle></el-button>-->
        <!--        </div>-->
        <area-select-footer v-show="$store.state.isInSlicer==false"/>

        <copyright/>

      </div>
    </div>
  </div>
</template>

<script>
import {emailLogin, emailVerifyLogin, sendEmail, userInfo} from "@/api/api"
import {OnClickGetLoginInfo, openPrivacyPolicy, openUserAgreement} from "@/utils/studioWXMessage";
import {translateResMessage} from "~/utils/translateResMessage";

export default {

  data() {
    return {
      errorMsg: '',//错误提示信息
      showPassword: false,// 是否显示密码
      isSendingCode: false,//是否在发送验证码
      codeCountDown: 0,//验证码发送倒计时
      chooseTabName: "passwordLogin",//选中的tab name，一开始默认是密码登录
      isActiveSub: false,//是否可以点击提交按钮
      ruleForm: {
        userEmail: '',
        password: '',
        emailCode: '',
        checked: false,// 初始值设为 false，表示未勾选
      },
      lan: "",//语言
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      //this.$notify.success({
      //   title: this.$t('h.common.tip'),
      //   message: this.$t('h.common.tipAlreadyLogin'),
      // })
      this.$router.push("/account/localLogin")//本地有token进入登录页面跳转到 本地登录页面
    }
  },
  mounted() {
    window.isOpenUserAgreement = this.isOpenUserAgreement;
    window.isOpenPrivacyPolicy = this.isOpenPrivacyPolicy;
  },

  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
    getRules() {
      if (this.chooseTabName === "passwordLogin") {
        return {
          userEmail: [
            {required: true, message: this.$t('h.common.userEmailRequired'), trigger: 'blur'},
            {type: 'email', message: this.$t('h.common.userEmailInvalid'), trigger: ['blur', 'change']}
          ],
          password: [
            {required: true, message: this.$t('h.common.passwordInputLabel'), trigger: 'blur'},
            {min: 6, max: 20, message: this.$t('h.common.passwordInputLengthErrorLabel'), trigger: ['blur', 'change']},
          ],
          checked: [
            // {type: 'array', required: true, message: '请阅读并同意协议', trigger: 'change'},
          ],
          emailCode: [],
        }
      } else if (this.chooseTabName === "emailLogin") {
        return {
          userEmail: [
            {required: true, message: this.$t('h.common.userEmailRequired'), trigger: 'blur'},
            {type: 'email', message: this.$t('h.common.userEmailInvalid'), trigger: ['blur', 'change']}
          ],
          emailCode: [
            {required: true, message: this.$t('h.common.emailCodeRequired'), trigger: 'blur'},
          ],
          checked: [
            // {type: 'array', trigger: 'change'},
          ],
          password: [],
        }
      }
    },

    getSubStyle() {
      this.$nextTick(() => {
        // if (this.submitForm('ruleForm')===true,false){
        //   //启用
        //   this.isActiveSub = false
        //   return {
        //     color:"#FFFFFF",
        //     backgroundColor: "#2196f4",
        //   }
        // }else{
        //   //禁用
        //   this.isActiveSub = true
        //   return {
        //     color: "#A2ACB8",
        //     backgroundColor: "#E5E8EB",
        //   }
        // }
      })
    }
  },
  methods: {
    isOpenUserAgreement() {
      if (this.$store.state.isInSlicer == true) {
        openUserAgreement()
      } else {
        console.log("不触发openUserAgreement")
        const baseUrl = window.location.origin; // 获取基础 URL
        const url = `${baseUrl}/#/policies/terms`;
        window.open(url, '_blank');
      }
    },
    isOpenPrivacyPolicy() {
      if (this.$store.state.isInSlicer == true) {
        openPrivacyPolicy()
      } else {
        console.log("不触发openPrivacyPolicy")
        const baseUrl = window.location.origin; // 获取基础 URL
        const url = `${baseUrl}/#/policies/privacy`;
        window.open(url, '_blank');
      }
    },
    //密码切换显示
    switchPassword() {
      this.showPassword = !this.showPassword;
    },
    handleTabClick(tab, event) {
      // console.log("tab", tab);
      // console.log("event", event);
      console.log("tab", tab.name);
      this.chooseTabName = tab.name
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate(); // 清除表单验证状态
      })
    },
    submitForm(formName, isNeedAgree = true) {
      this.errorMsg = ""//每次提交前清空内容
      this.$refs[formName].validate((valid) => {
        if (valid && (this.agreeTip() === true && isNeedAgree || !isNeedAgree)) {
          if (this.chooseTabName === "passwordLogin") {
            let formData = new FormData();
            formData.append('email', this.ruleForm.userEmail);
            formData.append('password', this.ruleForm.password);
            emailLogin(formData).then(res => {
              console.log(res)
              if (res.status === 0) {
                this.setToken = res.data.token
                console.log('密码登录成功，准备存放token', this.setToken);
                localStorage.setItem("token", this.setToken)
                this.$store.commit("saveUserToken", this.setToken)
                OnClickGetLoginInfo(this.setToken)
                this.$router.push("/account/userCenter")
              } else {
                let result=translateResMessage(res.message)
                this.errorMsg = this.$t(result)
                //this.$notify.error({
                //   title: this.$t('h.common.tip'),
                //   message: this.errorMsg,
                // })
              }
            })
          } else if (this.chooseTabName === "emailLogin") {
            let formData = new FormData();
            formData.append('email', this.ruleForm.userEmail);
            formData.append('code', this.ruleForm.emailCode);
            emailVerifyLogin(formData).then(res => {
              console.log(res)
              if (res.status === 0) {
                this.setToken = res.data.token
                console.log('邮箱登录成功，准备存放token', this.setToken);
                localStorage.setItem("token", this.setToken)
                this.$store.commit("saveUserToken", this.setToken)
                OnClickGetLoginInfo(this.setToken)
                userInfo().then(userInfoRes => {
                  if (userInfoRes.status === 0) {
                    //this.$notify.success({
                    //   title: this.$t('h.common.tip'),
                    //   message: this.$t('h.common.tipWelcomeBack') + userInfoRes.data.nick_name,
                    // });
                    this.$store.commit("saveUserInfo", userInfoRes.data)
                    this.$router.push("/account/userCenter")
                  }
                })
              } else {
                console.log('邮箱登录失败');
                let result=translateResMessage(res.message)
                this.errorMsg = this.$t(result)
                //this.$notify.error({
                //   title: this.$t('h.common.tip'),
                //   message: this.errorMsg,
                // })
              }
            })
          }
          return true;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //发送验证码
    sendVerificationCode() {
      this.$refs.ruleForm.validateField('userEmail', (errorBackMsg) => {
        console.warn(errorBackMsg)
        if (errorBackMsg) {
          // 验证未通过，显示错误信息
          //this.$notify.error({
          //   title: this.$t('h.common.tip'),
          //   message: errorBackMsg,
          // });
          return
        } else {
          // 验证通过，准备发送
          if (this.codeCountDown > 0 || this.isSendingCode) {
            return; // 防止重复点击发送
          }
          this.isSendingCode = true;

          let formData = new FormData();
          formData.append('email', this.ruleForm.userEmail);
          formData.append('type', '1');
          sendEmail(formData).then(res => {
            if (res.status === 0) {
              console.log('发送验证码成功', res);
              this.startCountdown();
              //this.$notify.success({
              //   title: this.$t('h.common.tip'),
              //   message: this.$t('h.common.emailCodeSentSuccess'),
              // });
            } else {
              let result=translateResMessage(res.message)
              this.errorMsg = this.$t(result)
              //this.$notify.error({
              //   title: this.$t('h.common.tip'),
              //   message: this.errorMsg,
              // })
            }
            this.isSendingCode = false;
          })
        }
      });
    },
    //验证码倒计时 从点击按钮开始计算 也可以改成从发送成功开始计算
    startCountdown() {
      this.codeCountDown = 60;
      const timer = setInterval(() => {
        this.codeCountDown--;
        if (this.codeCountDown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    //判断是否勾选同意 并弹窗引导用户
    agreeTip() {
      console.warn(this.ruleForm.checked)
      if (this.ruleForm.checked === true) {
        return true
      }
      this.$confirm(this.$t('h.common.pleaseAgreeFirst') + ' <a onclick="isOpenUserAgreement()"  style="color: #2196F4;text-decoration: underline;cursor: pointer;">' + this.$t('h.common.userAgreement') + '</a> ' + this.$t('h.common.and') + ' <a onclick="isOpenPrivacyPolicy()" style="color: #2196F4;text-decoration: underline;cursor: pointer;">' + this.$t('h.common.privacyPolicy') + '</a> ', this.$t('h.common.tip'), {
        confirmButtonText: this.$t('h.common.agree'),
        cancelButtonText: this.$t('h.common.refuse'),
        type: 'warning ',
        showClose: "false",
        dangerouslyUseHTMLString: "true",
      }).then(() => {
        //this.$notify.success({
        //   title: this.$t('h.common.tip'),
        //   message: this.$t('h.common.agree'),
        // });
        this.ruleForm.checked = true
        return true
      }).catch(() => {
        //this.$notify.error({
        //   title: this.$t('h.common.tip'),
        //   message: this.$t('h.common.refuse'),
        // });
        this.ruleForm.checked = false
        return false
      });
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';

.mainBoxForm {
  @include background_color("background_color");
  @include font_color("text-color");
}

>>> .loginBoxHeader {

  font-size: 20px;
  font-weight: bolder;
  padding: 20px 0;
  border-radius: 15px 15px 0 0; /* 顶部左右圆角，其余角为直角 */
  border-bottom: 1px solid;
  text-align: center;

  @include border_color('navBorderColor');
  @include background_color("navBgColor");
  @include font_color("navColor");
}

>>> .loginFormBox {
  width: 500px;
  align-items: center;
  text-align: center;
  position: relative;
  top: 44%;
  left: 50%;
  transform: translate(-50%, -50%);

  .formInputWidth{
    width: 330px;
    margin: 0px auto;
    padding: 10px 0;

  }
  .sendCodeBtn {
    border: none;
    color: #ACACAC;
    padding: 0;
    @include background_color('background_color');
    font-size: 12px;
  }

  .loginFormBoxHeader {
    color: #212B36;
    font-size: 20px;
    display: inline-block;
    @include font_color("text-color");
  }


  .elLinkFooter {
    font-size: 16px;
  }

  .subBtn {
    width: 100%;
    font-size: 15px;
    color: #FFFFFF;
    @include background_color("qidi_blue");
  }

  .subBtn:hover {
    width: 100%;
    font-size: 15px;
    color: #FFFFFF;
    backgroundColor: #060c76;
    //background-color: #E5E8EB;
    //border: none;
  }

  .iconStyle {
    font-size: 15px;
  }

  .qq {
    color: #F4F4F4;
    background-color: #30A5DD;
  }

  .weixin {
    color: #F4F4F4;
    background-color: #28C445;
  }

  .weibo {
    color: #F4F4F4;
    background-color: #EA5D5C;
  }

  .apple {
    color: #F4F4F4;
    background-color: #616161;
  }

  .input_icon {
    cursor: pointer;
    width: 24px;
    padding-top: 8px;
    padding-right: 6px;
  }

  .el-input__inner::placeholder {
    @include font_color("elInputPlaceholderColor");
  }
  .el-input__inner{
    height: 25px;
    border-radius: 0px;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 1px;

    padding: 0; /* 确保 padding 设置为 0 */
    margin: 0; /* 确保 margin 设置为 0 */
    box-sizing: border-box;
    /*outline: medium;*/
    @include font_color('text-color');
    @include background_color("background_color");
  }

  .el-input__inner:hover {
    border-bottom-width: 2px;
    @include border_color("text-color");
  }

  .el-input__inner:focus {
    border-bottom-width: 2px;
    @include border_color("elInputBorderFocusColor");
  }
  .agreeCheckbox {
    font-size: 2px;
    text-align: center;
    align-items: center;
    margin: 0;
    padding: 0;
  }

  agreeCheckboxInput {
    margin-top: 50px;
  }

  .agreeA {
    margin: 0;
    padding: 0;
    text-decoration: none;
    @include font_color("qidi_blue");
  }

  .agreeA:hover {
    text-decoration: underline;
  }

  .myCheckBox {
    width: 330px;
    @include font_color("checkBoxColor");
  }

  .el-checkbox__inner {
    border: 2px solid #757575;
    border-radius: 5px;
    width: 15px;
    height: 15px;
  }


  /* 设置选中后的文字颜色 */
  .myCheckBox .el-checkbox__input.is-checked + .el-checkbox__label {
    @include font_color("checkBoxColor");
  }

  /* 设置选中后对勾框的边框和背景颜色 */
  .myCheckBox .el-checkbox__input.is-checked .el-checkbox__inner, .myCheckBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    @include border_color("qidi_blue");
    @include background_color("qidi_blue");
  }

  .formCheckBox {
    text-align: center;
    padding: 0;
    margin: 0 auto;
    margin-top: 10px;
  }

  .checkbox-content {
    font-size: 12px;
    display: flex;
    flex-wrap: wrap;
    width: 330px;
    margin: 0 auto;
  }
  .checkbox-content a {
    white-space: nowrap; /* 确保链接不换行 */
    margin:0  4px ; /* 可选：添加一些间距 */
  }

}
.agreeA {
  margin: 0;
  padding: 0;
  text-decoration: none;
  @include font_color("qidi_blue");
}

.agreeA:hover {
  text-decoration: underline;
}

.link-style {
  color: #2196F4;
  text-decoration: underline;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/views/account/login.vue